import React from 'react'
import { useRouter } from '@tanstack/react-router'
import { Button } from '../../ui/Button'
import styles from './RouterError.module.css'

interface RouterErrorProps {
  error: Error
  reset?: () => void
}

export const RouterError: React.FC<RouterErrorProps> = ({ error, reset }) => {
  const router = useRouter()

  const handleRetry = () => {
    if (reset) {
      reset()
    } else {
      router.invalidate()
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.title}>Something went wrong</h2>
        <p className={styles.message}>{error.message || 'An unexpected error occurred while loading this page.'}</p>
        <div className={styles.actions}>
          <Button variant="primary" onClick={handleRetry}>
            Try Again
          </Button>
          <Button variant="secondary" onClick={() => window.history.back()}>
            Go Back
          </Button>
        </div>
        {import.meta.env.DEV && (
          <details className={styles.details}>
            <summary>Error Details</summary>
            <pre>{error.stack}</pre>
          </details>
        )}
      </div>
    </div>
  )
}
